import {
  BreadCrumbItem,
  BreadCrumbs as BreadCrumbsComponent,
} from '@tfecom-thermofisher/react-komodo-design';
import React from 'react';

import Message from '../Message';
import { staticBreadCrumbs } from './constants';
import messages from './messages';

const BreadCrumbs = () => {
  const isCurrent = (index) => index === staticBreadCrumbs.length - 1;

  return (
    <div className="bread-crumbs">
      <BreadCrumbsComponent>
        {staticBreadCrumbs.map(({ id, url, name }, index) => (
          <BreadCrumbItem
            data-testid={`breadcrumb-${id}`}
            key={`breadcrumb-${id}`}
            href={url}
            current={isCurrent(index)}
          >
            <Message message={messages[name]} literal />
          </BreadCrumbItem>
        ))}
      </BreadCrumbsComponent>
    </div>
  );
};

export default BreadCrumbs;
